/* global __cmp */
/* eslint no-undef: "error" */

const hasGoogleMapsConsentNotice = () => document.querySelector('.js_google-maps-consent-notice');

export function handleGoogleMapsConsentNotice() {
    const consentData = __cmp('getCMPData');
    if (!consentData) return;
    if (!hasGoogleMapsConsentNotice()) return;
    if (consentData.vendorConsents.s1104) return;

    $('.js_google-maps-consent-notice').removeClass('_d-none');
}

export default function cmpListener() {
    const pageReload = () => location.reload();

    const handleRolexCookie = () => {
        const cmpData = __cmp('getCMPData');
        const rolexConsent = cmpData.vendorConsents.c41491;
        const rolexMarketing = cmpData.vendorConsents.c85207;
        const consentCookieValue = rolexConsent ? 'true' : 'false';
        const marketingCookieValue = rolexMarketing ? 'true' : 'false';

        document.cookie = `rlx-consent=${consentCookieValue};path=/;max-age=31536000`;
        document.cookie = `rlx-marketing=${marketingCookieValue};path=/;max-age=31536000`;
    };

    const checkConsentExists = () => {
        const consentStatus = __cmp('consentStatus');

        handleRolexCookie();

        if (consentStatus.userChoiceExists === true) {
            __cmp('addEventListener', ['consentrejected', pageReload, false], null);
            __cmp('addEventListener', ['consentcustom', pageReload, false], null);
        }
    };

    if (typeof __cmp === 'function') {
        __cmp('addEventListener', ['settings', checkConsentExists, false], null);
        __cmp('addEventListener', ['consentrejected', handleRolexCookie, false], null);
        __cmp('addEventListener', ['consentapproved', handleRolexCookie, false], null);
        __cmp('addEventListener', ['consentcustom', handleRolexCookie, false], null);

        if (hasGoogleMapsConsentNotice()) {
            __cmp('addEventListener', ['consent', handleGoogleMapsConsentNotice, false], null);
            __cmp('addEventListener', ['consentapproved', handleGoogleMapsConsentNotice, false], null);
            __cmp('addEventListener', ['consentcustom', handleGoogleMapsConsentNotice, false], null);
        }
    }
}
